import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableUpsLabelTermsV2 = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableUpsLabelTermsV2);
};
